import { tl } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { PAGES, PageType } from '../../constants/pages';

/**
 * タブ切り替え計測
 * @param page
 * @param loginStatus
 */
export const measureChangeTabState = (page: PageType, loginStatus = false) => {
  let linkTrackVars =
    'channel,events,prop1,prop4,prop5,prop32,prop62,prop63,prop68,prop69,eVar57,eVar68,eVar77,eVar78,eVar79,eVar82,eVar100,eVar107,eVar116,eVar127';
  if (page === PAGES.JOB_SEARCH_DETAIL) {
    linkTrackVars = loginStatus
      ? 'prop1,prop2,prop4,prop5,prop32,prop62,prop63,prop68,prop69,prop73,prop75,eVar1,eVar2,eVar27,eVar57,eVar68,eVar73,eVar77,eVar78,eVar79,eVar82,eVar100,eVar107,eVar116,eVar127,eVar171'
      : 'prop1,prop2,prop4,prop5,prop32,prop62,prop63,prop68,prop69,prop73,prop75,eVar1,eVar2,eVar27,eVar57,eVar68,eVar73,eVar77,eVar78,eVar100,eVar107,eVar116,eVar171';
  }
  tl('view_tabswitching', {
    linkTrackVars,
    linkTrackEvents: 'event218',
    events: 'event218',
  });
};

/**
 * クリック計測 PickUpタブ展開 C31
 * @param page
 * @param loginStatus
 */
export const measureClickTabPickup = (page: PageType, loginStatus = false) => {
  let linkTrackVars =
    'channel,prop1,prop4,prop69,prop71,prop75,eVar57,eVar77,eVar78,eVar79,eVar82,eVar107,eVar116,eVar127';
  if (page === PAGES.JOB_SEARCH_DETAIL) {
    linkTrackVars = loginStatus
      ? 'prop1,prop2,prop4,prop5,prop68,prop69,prop73,prop75,eVar1,eVar2,eVar27,eVar57,eVar68,eVar73,eVar77,eVar78,eVar79,eVar82,eVar100,eVar107,eVar116,eVar123,eVar127,eVar171'
      : 'prop1,prop2,prop4,prop5,prop32,prop68,prop69,prop71,prop73,prop75,eVar1,eVar2,eVar27,eVar57,eVar68,eVar73,eVar77,eVar78,eVar100,eVar116,eVar123,eVar171';
  }
  tl('JobdetailTabPickup', {
    linkTrackVars,
  });
};

/**
 * 閲覧回数に応じた計測
 * @param viewTimes
 */
export const measureView2timesMoreJobSearchDetail = (viewTimes: number) => {
  if (viewTimes < 2) return;
  const customLink = viewTimes === 2 ? 'view_2timesmore' : 'view_3timesmore';
  const event = viewTimes === 2 ? 'event212' : 'event214';
  // PV計測より前に発火しないように発火を遅らせる
  setTimeout(() => {
    tl(customLink, {
      linkTrackVars:
        'channel,events,prop1,prop4,prop5,prop32,prop62,prop63,prop68,prop69,eVar57,eVar68,eVar77,eVar78,eVar79,eVar82,eVar100,eVar107,eVar116,eVar127',
      linkTrackEvents: event,
      events: event,
    });
  }, 1000);
};

/**
 * E原稿動画化ABテストのPickUpタブ移動測定
 */
export const measureAbTestForManuscriptEMovePickUp = (): void => {
  tl('test_e_detail_pickup_A', {});
};

/**
 * Fire AB test event for Skill Matching Cassette feature.
 * Fires custom_ab_dodasite_26488_[original|test1|test2] for all valid groups (1, 2, 3).
 *
 * @param abTestGroup AB test group number (1=original, 2=test1, 3=test2, or null/undefined=no event)
 */
export const measureMatchedTagCassetteAbTest = (
  abTestGroup: number | null | undefined
): void => {
  if (abTestGroup === null || abTestGroup === undefined) {
    return;
  }

  const abTestPatternMap: Record<number, string> = {
    1: 'original',
    2: 'test1',
    3: 'test2',
  };

  const pattern = abTestPatternMap[abTestGroup];
  if (!pattern) {
    return;
  }

  tl(`custom_ab_dodasite_26488_${pattern}`, {});
};

/**
 * Fire impression event for Skill Matching Cassette feature.
 * Fires custom_imp_tag_skill_N_* event only for test groups (2 and 3).
 *
 * @param matchedTags Array of matched skill tags
 */
export const measureMatchedTagCassetteImpression = (
  matchedTags: string[]
): void => {
  if (matchedTags.length > 0) {
    const tagsJoined = matchedTags.join('_');
    tl(`custom_imp_tag_skill_${matchedTags.length}_${tagsJoined}`, {});
  } else {
    tl('custom_imp_tag_skill_0', {});
  }
};

/**
 * Fire click event when user expands matched tags cassette.
 */
export const measureClickMoreSkillTag = (): void => {
  tl('custom_click_more_skill_tag', {});
};
